import { stripTrailingZeroCents } from '@/utils/deposit-utils'
import { useI18n } from 'vue-i18n'

export function useCurrencyFormatter() {
  const { n } = useI18n()

  const formatCurrencyFromPence = (amount: number): string => {
    const formatted = n(amount / 100, 'currency')
    return amount % 100 === 0 ? stripTrailingZeroCents(formatted) : formatted
  }

  const formatCurrencyFromPounds = (amount: number): string => {
    const formatted = n(amount, 'currency')
    return Number.isInteger(amount)
      ? stripTrailingZeroCents(formatted)
      : formatted
  }

  return {
    formatCurrencyFromPence,
    formatCurrencyFromPounds,
  }
}
